import {
  GET_VIBE_WHEEL_HISTORY,
  GET_VIBE_WHEEL_STATS,
  GET_VIBE_WHEEL,
  RESET_VIBE_WHEEL_COIN,
} from "./type";

const initialState = {
  vibewheelHistory: [],
  vibeWheelStats: {},
  vibeWheel: null,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    limit: 20
  }
};

export const vibewheelHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VIBE_WHEEL_HISTORY:
      return {
        ...state,
        vibewheelHistory: action.payload.history,
        pagination: action.payload.pagination
      };
    case GET_VIBE_WHEEL_STATS:
      return {
        ...state,
        vibeWheelStats: action.payload,
      };
    case GET_VIBE_WHEEL:
      return {
        ...state,
        vibeWheel: action.payload,
      };
    case RESET_VIBE_WHEEL_COIN:
      return {
        ...state,
        vibeWheel: action.payload,
      };
    default:
      return state;
  }
};
